import React from 'react';
import Box from 'ui-box';
import { majorScale } from '.';
import { Container, Grid } from './PageContainer';

export const PageLoader = () => (
  <Container>
    <Grid rowGap={majorScale(4)} columnGap={majorScale(4)}>
      <Box
        className="skeleton col-span-12"
        height={majorScale(10)}
        borderRadius={6}
      />
      <Box
        className="skeleton col-span-12 lg:col-span-4"
        height={majorScale(40)}
        borderRadius={6}
      />
      <Box
        className="skeleton col-span-12 lg:col-span-8"
        height={majorScale(40)}
        borderRadius={6}
      />
    </Grid>
  </Container>
);
